export const USER_TRACKS_LOADING = "USER_TRACKS_LOADING";
export const USER_TRACKS_LOADED = "USER_TRACKS_LOADED";
export const USER_TRACKS_LOAD_ERROR = "USER_TRACKS_LOAD_ERROR";